import React from "react";
import ReactDOM from "react-dom/client";
import './index.css';
import App from "@/App";
import { TimezoneProvider } from "@/utils/TimezoneContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <TimezoneProvider>
    <App />
    </TimezoneProvider>
  </React.StrictMode>,
);
